import * as React from 'react'

import { BoxList } from '@factorialco/deprecated-design-system'
import { DocumentsSignatureStatusEnum } from 'generated/resources/graphql'

import DocumentSignatureStatusBox from 'modules/documents/components/DocumentPreview/Content/Esignature/DocumentSignatureStatusBox'
import SignatureBox from 'modules/documents/components/DocumentPreview/Content/Esignature/SignatureBox'
import type { EsignatureSignature } from 'modules/esignatures/hooks/signatures/useGetEsignatureSignatures'

interface Props {
  signatures: EsignatureSignature[]
  documentSignatureStatus: DocumentsSignatureStatusEnum
  requestDate?: Date
  documentId: string
}

const SignaturesList = ({
  signatures,
  documentSignatureStatus,
  requestDate,
  documentId,
}: Props) => {
  return (
    <BoxList>
      {
        <DocumentSignatureStatusBox
          status={documentSignatureStatus}
          requestDate={requestDate}
          documentId={documentId}
        />
      }
      {signatures.map((signature) => (
        <SignatureBox signature={signature} key={signature.id} />
      ))}
    </BoxList>
  )
}

export default SignaturesList
